import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(10.75)};
  block-size: ${spacing(10.75)};
`
export default createSvgIcon(
  <svg
    className="footer__icon"
    fill="none"
    height="86"
    viewBox="0 0 86 86"
    width="86"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="43"
      cy="43"
      fill="#252525"
      r="42"
      stroke="white"
      strokeWidth="2"
    />
    <path
      clipRule="evenodd"
      d="M23 29.5113C23 25.3629 26.2124 22 30.175 22H56.825C60.7876 22 64 25.3629 64 29.5113C64 33.6596 60.7876 37.0225 56.825 37.0225H40.7165L38.2503 28.2618C37.7004 26.3085 35.7674 25.1251 33.8735 25.5823C31.9429 26.0484 30.7637 28.0452 31.2287 30.0609L32.8348 37.0225H30.175C26.2124 37.0225 23 33.6596 23 29.5113ZM33.2319 29.6025C33.0305 28.7294 33.5413 27.8644 34.3775 27.6625C35.1979 27.4644 36.0352 27.977 36.2734 28.8232L40.1207 42.4901L55.3132 44.9341C56.7395 45.1636 57.8431 46.3804 57.9745 47.8684L59.2728 62.5663C59.4367 64.4213 58.0493 66 56.2553 66H42.1707C41.1814 66 40.2428 65.5089 39.646 64.6791L28.0125 48.5032C27.4481 47.7184 27.5698 46.6244 28.2889 46.0183C29.0093 45.4111 30.0744 45.5087 30.7055 46.2398L36.6914 53.1731L38.4546 52.2405L33.2319 29.6025Z"
      fill="#F7F7F7"
      fillRule="evenodd"
    />
  </svg>,
  'Dashboard',
  {viewBox: '0 0 86 86', className},
)
